// removed by extract-text-webpack-plugin
module.exports = {"appBackdrop":"Backdrop__appBackdrop__1RFGE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Backdrop/Backdrop.css
// module id = 285
// module chunks = 0